export default "__VITE_ASSET__043ad4b7__"